import { FC } from 'react';
import { useFormContext } from '../../../../../../contexts/FormContext';
import { FormType } from '../../../../../../types/FormTypes';
import { BasicButton } from '../../../../../shared/buttons/BasicButton';
import { CallToActionCard } from './CallToActionCard';
import { FeatureDescriptionCard } from './FeatureDescriptionCard';
import { HeroHeaderCard } from './HeroHeaderCard';
import { SubheaderCard } from './SubheaderCard';

import styles from './WebsiteOutputs.module.css';

export const WebsiteOutputs: FC = () => {
  const {
    formType,

    heroHeaderInput,
    personaHeroHeaderInput,
    subheaderInput,
    personaSubheaderInput,
    featureDescriptionInput,
    personaFeatureDescriptionInput,
    callToActionInput,
    personaCallToActionInput,

    editedOutput,
    generatedOutput,
    lastGeneratedFormat,
    submitWebsiteForm,
    loading,
  } = useFormContext();

  // if (!heroHeaderInput && !subheaderInput && !featureDescriptionInput)
  //   return null;

  const websiteValues = () => {
    switch (formType) {
      default:
      case FormType.HERO_HEADER:
        return heroHeaderInput;
      case FormType.PERSONA_HERO_HEADER:
        return personaHeroHeaderInput;
      case FormType.SUBHEADER:
        return subheaderInput;
      case FormType.PERSONA_SUBHEADER:
        return personaSubheaderInput;
      case FormType.FEATURE_DESCRIPTION:
        return featureDescriptionInput;
      case FormType.PERSONA_FEATURE_DESCRIPTION:
        return personaFeatureDescriptionInput;
      case FormType.CALL_TO_ACTION:
        return callToActionInput;
      case FormType.PERSONA_CALL_TO_ACTION:
        return personaCallToActionInput;
    }
  };

  const LoadMoreButton = () => {
    if (generatedOutput.length === 0) return null;

    if (!lastGeneratedFormat || formType !== lastGeneratedFormat.formType)
      return null;

    return (
      <BasicButton
        type="button"
        text="Load More"
        disabled={loading}
        loading={loading}
        onClick={() => {
          submitWebsiteForm({
            values: websiteValues(),
            formType,
            keepPreviousResponses: true,
          });
        }}
        extraStyles={{
          margin: '30px auto',
          zIndex: 5,
        }}
      />
    );
  };

  return (
    <div className={styles['container']}>
      {editedOutput.map(({ text, id }, index) => {
        switch (lastGeneratedFormat?.formType) {
          case FormType.HERO_HEADER:
          case FormType.PERSONA_HERO_HEADER:
            return (
              <HeroHeaderCard
                key={text}
                text={text}
                responseIndex={index}
                id={id ?? ''}
              />
            );
          case FormType.SUBHEADER:
          case FormType.PERSONA_SUBHEADER:
            return (
              <SubheaderCard
                key={text}
                text={text}
                responseIndex={index}
                id={id ?? ''}
              />
            );
          case FormType.FEATURE_DESCRIPTION:
          case FormType.PERSONA_FEATURE_DESCRIPTION:
            return (
              <FeatureDescriptionCard
                key={text}
                text={text}
                responseIndex={index}
                id={id ?? ''}
              />
            );
          case FormType.CALL_TO_ACTION:
          case FormType.PERSONA_CALL_TO_ACTION:
            console.log(FormType.CALL_TO_ACTION);
            return (
              <CallToActionCard
                key={text}
                text={text}
                responseIndex={index}
                id={id ?? ''}
              />
            );
        }
      })}
      <LoadMoreButton />
    </div>
  );
};
